module.exports = __webpack_public_path__ + "static/media/Free_form.fad1faf8.jpeg";